import { Flex } from "antd";
import type { ComponentType, SVGProps } from "react";
import type { IPublicCourseResponse } from "../../../app/features/courses/courses.types";
import CertificateIcon from "../../../assets/icons/CertificateIcon";
import DepartmentIcon from "../../../assets/icons/DepartmentIcon";
import TimeIcon from "../../../assets/icons/TimeIcon";
import WebBrowserIcon from "../../../assets/icons/WebBrowserIcon";
import { cn } from "../../../utils/global.utils";
import type { TBreadcrumb } from "../../Breadcrumb";
import Breadcrumb from "../../Breadcrumb";
import CourseDetailsHeaderLoading from "./HeaderLoading";

type Props = {
  className?: string;
  breadcrumb: TBreadcrumb[];
  course?: IPublicCourseResponse;
  isLoading?: boolean;
};

export default function CourseDetailsHeader({
  className,
  breadcrumb,
  course,
  isLoading,
}: Props) {
  return (
    <header
      className={cn(
        "bg-gradient-to-l from-teal-700 to-gray-800 md:h-64 py-6 md:py-0 relative ",
        className
      )}
    >
      <Flex align="center" className="mini-container container h-full">
        <div className="max-w-2xl">
          <Breadcrumb breadcrumb={breadcrumb} className="!justify-start" />
          {isLoading ? (
            <CourseDetailsHeaderLoading />
          ) : (
            <>
              <h3 className="text-white text-3xl font-medium mt-5 mb-4">
                {course?.title}
              </h3>
              <div>
                <Item
                  icon={DepartmentIcon}
                  title="বিভাগ:"
                  value={course?.Category?.name || ""}
                />

                <Flex align="center" gap={16} wrap className="mt-4">
                  <Item
                    icon={TimeIcon}
                    iconClassName="text-xl text-theme-error-300"
                    title="সময়:"
                    value={course?.durationLabel || ""}
                  />
                  <Item
                    icon={WebBrowserIcon}
                    iconClassName="text-xl text-theme-error-300"
                    title="ভাষা:"
                    value={course?.language || "-"}
                  />
                  {!!course?.isCertificateEnabled && (
                    <Item
                      icon={CertificateIcon}
                      iconClassName="text-xl text-theme-error-300"
                      value="সমাপ্তির পর সার্টিফিকেট"
                    />
                  )}
                </Flex>
              </div>
            </>
          )}
        </div>
      </Flex>
    </header>
  );
}

type TItem = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  iconClassName?: string;
  title?: string;
  value: string;
};
const Item = ({ icon: Icon, iconClassName, title, value }: TItem) => (
  <Flex align="center">
    <Icon className={cn("relative -top-[1px] mr-3", iconClassName)} />
    {!!title && (
      <span className="text-white text-base font-medium mr-2">{title}</span>
    )}
    <span className="text-white text-base font-normal">{value}</span>
  </Flex>
);
